module.exports = __webpack_public_path__ + "img/icon-blanc.d422a157.png";